// i18n area 'tasks' — locale cs-CZ (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.cs-CZ.meta.json.
import type { enUS } from './tasks'

export const csCZ: typeof enUS = {
  macrotasks: {
    title: 'Makroúlohy',
    subtitle: 'Složené operace — lze pokračovat od selhaného kroku, nebo je přerušit',
    colType: 'Typ',
    colTarget: 'Objekt',
    colPhase: 'Fáze',
    colSteps: 'Kroky',
    empty: 'Žádné makroúlohy',
    detail: 'Podrobnosti',
    failedAt: 'selhala na',
    resume: 'Zkusit znovu od selhaného kroku',
    abort: 'Přerušit vše',
    cancel: 'Zrušit',
    actionError: 'Akce byla odmítnuta'
  },
  tasks: {
    title: 'Úlohy',
    searchPlaceholder: 'Hledat podle typu nebo cíle',
    type: 'Typ',
    target: 'Cíl',
    phaseLabel: 'Fáze',
    progress: 'Průběh',
    started: 'Zahájeno',
    finished: 'Ukončeno',
    node: 'Uzel',
    empty: 'Žádné úlohy',
    loadError: 'Úlohy se nepodařilo načíst — je backend TVirt dostupný?',
    limboHint: "Uzel '{node}' je nedostupný od {time} — úloha drží write lease na svém cíli, dokud se uzel nevrátí nebo není prohlášen za vypnutý",
    nodeAttested: 'Uzel prohlášen za vypnutý',
    phase: {
      queued: 'Ve frontě',
      running: 'Běží',
      succeeded: 'Dokončeno',
      failed: 'Selhalo',
      cancelled: 'Zrušeno',
      'failed-at-step': 'Selhalo na kroku',
      aborted: 'Přerušeno'
    },
    dropdown: {
      tooltip: 'Probíhající úlohy',
      title: 'Probíhající úlohy',
      empty: 'Žádné probíhající úlohy',
      viewAll: 'Zobrazit všechny úlohy'
    },
    detail: {
      open: 'Podrobnosti',
      scope: 'Rozsah',
      message: 'Zpráva',
      params: 'Parametry',
      result: 'Výsledek',
      errorTitle: 'Chyba',
      steps: 'Kroky',
      failedAt: 'selhala na',
      superseded: 'nahrazeno',

      // Standard dialogu (round #156): místo potomka v plánu rodiče,
      // rodič sám (otevíratelný na místě) a viník — selhaný krok.
      step: 'Krok',
      parent: 'Nadřazená úloha',
      failedStep: 'Selhaný krok',
      log: 'Log',
      logEmpty: 'Zatím žádné řádky logu',
      close: 'Zavřít'
    },
    actions: {
      cancel: 'Zrušit',
      resume: 'Zkusit znovu od selhaného kroku',
      abort: 'Přerušit vše (vrátí zpět dokončené kroky)',
      refused: 'Akce byla odmítnuta'
    }
  },
  events: {
    loadError: 'Deník se nepodařilo načíst — je backend TVirt dostupný?',
    title: 'Události',
    subtitle: 'Historická paměť clusteru: dokonané skutečnosti, od nejnovějších',
    filterSeverity: 'Závažnost',
    filterCategory: 'Kategorie',
    filterAll: 'Všechny',
    searchLabel: 'Hledat',
    searchPlaceholder: 'Hledat v celém deníku',
    subjectFilter: 'Události {subject} — zobrazit vše',
    colAt: 'Kdy',
    colSeverity: 'Závažnost',
    colType: 'Typ',
    colSubject: 'Předmět',
    colActor: 'Kdo',
    colNode: 'Node',
    colMessage: 'Zpráva',
    empty: 'Žádné události',
    loadMore: 'Načíst další',
    actorSystem: 'systém',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'ID události',
    taskCollectedHint: 'Task má kratší retenci: po sebrání odkaz už neodpovídá',
    severity: {
      info: 'Informace',
      warning: 'Varování',
      error: 'Chyba',
      critical: 'Kritické'
    },
    category: {
      lifecycle: 'Životní cyklus',
      config: 'Konfigurace',
      availability: 'Dostupnost',
      security: 'Bezpečnost'
    },
    type: {
      haNetsvcFailedOver: 'Failover síťové služby',
      haNetsvcNoCandidate: 'Síťová služba bez kandidátního uzlu',
      haNetsvcReaped: 'Lokální instance sklizena při návratu',
      netsvcFloatipMoved: 'Plovoucí IP se přesunula na jiného držitele',
      netsvcFloatipNoHolder: 'Plovoucí IP bez zdravého cíle',
      haAppFailedOver: 'Failover instance App',
      haAppNoCandidate: 'Instance App bez kandidátního uzlu',
      haAppStorageLocalSkip: 'Instance App nepřenesena: trvalá data jsou lokální na mrtvém uzlu',
      haAppReaped: 'Lokální pod instance App sklizen při návratu'
    }
  },
  audit: {
    loadError: 'Registr auditu se nepodařilo načíst — je backend TVirt dostupný?',
    title: 'Audit',
    subtitle: 'Kdo co udělal, kdy a nad jakým objektem — pokusy o úkon, včetně odmítnutých',
    filterOutcome: 'Výsledek',
    filterAll: 'Všechny',
    filterSudo: 'Jen povýšené úkony',
    colAt: 'Kdy',
    colActor: 'Kdo',
    colAction: 'Akce',
    colTarget: 'Objekt',
    colOutcome: 'Výsledek',
    colNode: 'Node',
    empty: 'Žádné zaznamenané úkony',
    loadMore: 'Načíst další',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Cesta',
    detailProblem: 'Důvod',
    detailTask: 'Task',
    detailClientIp: 'Odkud',
    detailId: 'ID záznamu',
    detailSession: 'Relace',
    taskHint: 'Výsledek přijatého úkonu žije v deníku událostí, pod stejným id tasku',
    outcome: {
      succeeded: 'Provedeno',
      accepted: 'Přijato',
      denied: 'Odepřeno',
      rejected: 'Odmítnuto',
      failed: 'Selhalo'
    }
  },
  notifications: {
    loadError: 'Oznámení se nepodařilo načíst — je backend TVirt dostupný?',
    actionError: 'Akce byla odmítnuta',
    title: 'Oznámení',
    subtitle: 'Cíle, do kterých fakta deníku opouštějí cluster',
    rulesTitle: 'Pravidla',
    rulesSubtitle: 'Která fakta odcházejí a kam',
    deliveriesTitle: 'Doručení',
    deliveriesSubtitle: 'Výsledek každého oznámení, s důvodem když selže',
    colName: 'Název',
    colKind: 'Typ',
    colWhere: 'Kam',
    colScope: 'Scope',
    colSeverity: 'Závažnost',
    colMatch: 'Filtr',
    colTargets: 'Cíl',
    colAt: 'Kdy',
    colState: 'Stav',
    colEvent: 'Událost',
    colAttempts: 'Pokusy',
    colOutcome: 'Výsledek',
    empty: 'Žádné řádky',
    matchAll: 'všechna fakta',
    test: 'Otestovat',
    testOk: 'Testovací oznámení doručeno do {target}',
    testFailed: 'Test do {target} selhal: {reason}',
    retry: 'Vrátit do fronty',
    retried: 'Doručení vráceno do fronty',
    grouped: 'a dalších {count} opakování',
    state: {
      failed: 'Selhalo',
      pending: 'Ve frontě',
      sending: 'Odesílá se',
      sent: 'Odesláno'
    },
    tabTargets: 'Cíle',
    tabRules: 'Pravidla',
    tabDeliveries: 'Doručení',
    targetCreateTitle: 'Nový cíl',
    ruleCreateTitle: 'Nové pravidlo',
    nameHint: 'Malá písmena, číslice a spojovníky; jedinečné v rámci scope',
    kindImmutableHint: 'Neměnné: změna typu znamená vytvořit jiný cíl',
    kindSmtp: 'Pošta (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Stav',
    enabledOn: 'Aktivní',
    enabledOff: 'Pozastavený',
    smtpHost: 'SMTP server',
    smtpPort: 'Port',
    smtpPortHint: 'Obvykle: 25 bez TLS, 587 se starttls, 465 s tls',
    smtpSecurity: 'Zabezpečení',
    smtpFrom: 'Odesílatel',
    smtpTo: 'Příjemci',
    smtpToHint: 'Jedna nebo více adres oddělených čárkou',
    webhookUrl: 'URL',
    payload: 'Obsah',
    payloadHint: 'S minimal zpráva a data události neopustí cluster',
    credential: 'Přihlašovací údaj',
    credentialNone: 'Žádný',
    credentialHintSmtp: 'Účet relay z keystore; žádný znamená anonymní SMTP',
    credentialHintWebhook: 'Podpisové tajemství z keystore; bez podpisu se za cluster může vydávat každý, kdo zná URL',
    minSeverityHint: 'Prahová hodnota, ne množina: od této závažnosti výše',
    categories: 'Kategorie',
    categoriesHint: 'Prázdné = všechny',
    types: 'Typy událostí',
    typesHint: 'Oddělené čárkou; prázdné = všechny. Neznámý typ je odmítnut',
    targetsHint: 'Alespoň jeden; musí být ve scope pravidla nebo v jeho předkovi',
    recursiveOn: 'Také podřízené scope',
    recursiveOff: 'Pouze tento scope',
    recursiveHint: 'Prostředky žijí v listech: bez potomků pravidlo na korenu neoznámí téměř nic',
    repeatWindow: 'Okno seskupení (s)',
    repeatWindowHint: 'V okně opakování neposílají poštu: počítají se u prvního. 0 vypíná',
    targetInUseError: 'Cíl {name} je ještě používán pravidlem'
  }
}
